function initAnimation() {
  const header = document.querySelector('.page-header-dark');
  const imageWrap = header?.querySelector('.page-header-dark__image');

  if (!header || !imageWrap) return;

  const onAnimationEnd = () => {
    imageWrap.classList.remove('animate');
    imageWrap.classList.add('animated');
    imageWrap.removeEventListener('animationend', onAnimationEnd);
  };

  if (window.innerWidth < 768 && window.innerHeight < 630) {
    onAnimationEnd();
    header.classList.add('fast');
    imageWrap.style.display = 'none';
  }else {
    imageWrap.addEventListener('animationend', onAnimationEnd);
    imageWrap.classList.add('animate');
  }

  
}

initAnimation();